export function Show({ when, whenFalse, children }) {
  return when ? <>{children}</> : whenFalse ? <>{whenFalse}</> : null;
}
